export const getInitials = (fullName: string) => {
  const nameParts = fullName.split(' ')
  const firstName = nameParts[0]
  const lastName = nameParts[1]
  const initials = firstName.charAt(0) + lastName.charAt(0)
  return initials
}
